import { tx } from "@/i18n/tx";
import { useState } from "react";
import { Plus, X } from "lucide-react";

const DAYS = [[1, "Lu"], [2, "Ma"], [3, "Me"], [4, "Je"], [5, "Ve"], [6, "Sa"], [7, "Di"]];
const fmt = (d) => (d ? d.split("-").reverse().join(".") : "");

export default function ClosuresEditor({ weekdays, closures, onChange }) {
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [label, setLabel] = useState("");

  const toggle = (d) => onChange({ closed_weekdays: weekdays.includes(d) ? weekdays.filter((x) => x !== d) : [...weekdays, d].sort() });
  const add = () => {
    if (!start) return;
    onChange({ closures: [...closures, { start, end: end && end >= start ? end : start, label: label.trim() }] });
    setStart(""); setEnd(""); setLabel("");
  };

  return (
    <div className="space-y-3" data-testid="closures-editor">
      <div>
        <p className="text-sm font-medium text-text-secondary mb-2">{tx("ui_closureseditor.k3bc71a")}</p>
        <div className="grid grid-cols-7 gap-1.5">
          {DAYS.map(([d, l]) => (
            <button type="button" key={d} onClick={() => toggle(d)} data-testid={`closed-day-${d}`}
              className={`h-11 rounded-xl text-sm font-semibold border transition-colors ${weekdays.includes(d) ? "bg-[#1C1C1C] text-white border-transparent" : "bg-white border-c text-text-secondary"}`}>
              {l}
            </button>
          ))}
        </div>
        <p className="text-[11px] text-text-secondary mt-1.5">{tx("ui_closureseditor.k8c6284")}</p>
      </div>
      <div>
        <p className="text-sm font-medium text-text-secondary mb-2">{tx("ui_closureseditor.k821a4c")}</p>
        {closures.length > 0 && (
          <ul className="space-y-1.5 mb-2" data-testid="closures-list">
            {closures.map((c, i) => (
              <li key={i} className="flex items-center gap-2 p-2 rounded-xl bg-surface-muted text-sm">
                <span className="flex-1 min-w-0 truncate">{fmt(c.start)}{c.end !== c.start ? ` → ${fmt(c.end)}` : ""}{c.label ? ` · ${c.label}` : ""}</span>
                <button type="button" onClick={() => onChange({ closures: closures.filter((_, j) => j !== i) })} className="w-9 h-9 rounded-lg flex items-center justify-center hover:bg-white" aria-label={tx("ui_closureseditor.k0b604a")} data-testid={`closure-remove-${i}`}><X className="w-4 h-4" /></button>
              </li>
            ))}
          </ul>
        )}
        <div className="grid grid-cols-2 gap-2">
          <input type="date" value={start} onChange={(e) => setStart(e.target.value)} className="input-c text-sm" aria-label="Du" data-testid="closure-start" />
          <input type="date" value={end} min={start} onChange={(e) => setEnd(e.target.value)} className="input-c text-sm" aria-label="Au" data-testid="closure-end" />
          <input value={label} onChange={(e) => setLabel(e.target.value)} placeholder={tx("ui_closureseditor.k91c48a")} className="input-c text-sm" data-testid="closure-label" />
          <button type="button" onClick={add} disabled={!start} className="btn-secondary !py-2 text-sm flex items-center justify-center gap-1 disabled:opacity-50" data-testid="closure-add"><Plus className="w-4 h-4" />{tx("ui_closureseditor.k18d925")}</button>
        </div>
      </div>
    </div>
  );
}
